
import { useState, useEffect } from 'react';
import {ApiUrl} from "../../ApiUrl"

const useFetchNationalities = () => {
  const [nationalities, setNationalities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}NATIONALITY/GetAllNationality/`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setNationalities(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        setError(err.message);
        setNationalities([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNationalities();
  }, []);

  return { nationalities, loading, error };
};

export default useFetchNationalities;
